var _path, _g, _path2, _g2, _path3, _g3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 54,
    viewBox: "0 0 80 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_165_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 6,
    width: 53,
    height: 42
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.695 6.42871H0.304993V47.0836H52.695V6.42871Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_165_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.7156 47.0836H6.29613C2.98865 47.0836 0.316772 44.4 0.316772 41.1043V12.4081C0.316772 9.10059 3.00042 6.42871 6.29613 6.42871H46.7156C50.0231 6.42871 52.695 9.11236 52.695 12.4081V41.0925C52.7068 44.4 50.0231 47.0836 46.7156 47.0836Z",
    fill: "url(#paint0_linear_165_2)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_165_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 6,
    width: 53,
    height: 42
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.695 6.42871H0.304993V47.0836H52.695V6.42871Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_165_2)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M55.6258 26.733V25.8031H33.1797V19.8237L38.1938 14.8096H53.9309V13.8797H37.8054L32.5205 19.1646H26.5412V4.23975H25.6113V19.1528H19.6319L14.347 13.8679H-1.79015V14.7978H13.9469L18.961 19.812V25.7913H-3.49686V26.7212H18.961V32.7005L13.4878 38.1738H-1.79015V39.1036H13.8645L19.6084 33.3479H25.5878V48.261H26.5176V33.3714H32.497L38.2409 39.1272H53.8955V38.1973H38.6529L33.1797 32.7241V26.7447H55.6258V26.733ZM32.238 32.4416H19.8791V20.0827H32.238V32.4416Z",
    fill: "url(#paint1_linear_165_2)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_165_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 6,
    width: 53,
    height: 42
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.695 6.42871H0.304993V47.0836H52.695V6.42871Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_165_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.073 27.2154V26.2855H33.6152V20.3062L38.6293 15.292H54.3663V14.3621H38.2409L32.956 19.647H26.9767V4.72217H26.0468V19.6352H20.0674L14.7708 14.3621H-1.34289V15.292H14.3941L19.4083 20.3062V26.2855H-3.04959V27.2154H19.4083V33.1947L13.9351 38.668H-1.34289V39.5978H14.3117L20.0557 33.8421H26.035V48.7552H26.9649V33.8656H32.9442L38.6882 39.6214H54.3428V38.6915H39.0884L33.6152 33.2183V27.2389H56.073V27.2154ZM32.6853 32.9358H20.3264V20.5769H32.6853V32.9358Z",
    fill: "#231912"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0775 15.5063C72.8448 18.6002 74.3746 22.6055 74.3746 26.7563C74.3746 30.9072 72.8448 34.9125 70.0775 38.0063",
    stroke: "white",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5336 18.8813C67.5949 20.9843 68.7495 23.8116 68.7495 26.7563C68.7495 29.7011 67.5949 32.5284 65.5336 34.6313",
    stroke: "white",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5174 22.8188C62.548 23.8703 63.1253 25.284 63.1253 26.7563C63.1253 28.2287 62.548 29.6424 61.5174 30.6938",
    stroke: "white",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_165_2",
    x1: 2.15884,
    y1: 6.80277,
    x2: 53.4232,
    y2: 48.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B56110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1507,
    stopColor: "#B56110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4638,
    stopColor: "#E5AD5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6129,
    stopColor: "#F9CC7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7204,
    stopColor: "#FFE6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8387,
    stopColor: "#F9CC7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B56110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_165_2",
    x1: -3.49686,
    y1: 26.2665,
    x2: 55.6291,
    y2: 26.2665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B56110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1507,
    stopColor: "#B56110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4638,
    stopColor: "#E5AD5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6129,
    stopColor: "#F9CC7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7204,
    stopColor: "#FFE6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8387,
    stopColor: "#F9CC7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B56110"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip);
export default __webpack_public_path__ + "static/media/chip.ba01fd31817e37b1ca9e04b72b9156bc.svg";
export { ForwardRef as ReactComponent };